import initialState from './initialState';

export default function multicryptoReducer(state = initialState.multicrypto, action){

  switch(action.type){

    case 'SELECT_COIN':
      return Object.assign({}, state, {
        coin: action.coin
      });

    case 'SET_ENABLED_COINS':
      return Object.assign({}, state, {
        enabledCoins: action.enabledCoins
      });

    case 'LOADING_COINS':
      return Object.assign({}, state, {
        loadingCoins: true
      });

    case 'STOP_LOADING_COINS':
      return Object.assign({}, state, {
        loadingCoins: false
      });

    case 'RESET_COIN':
    case 'CANCEL_OPERATION':
      return {
        ...initialState.multicrypto,
        enabledCoins: state.enabledCoins
      }
    
    default: 
      return state;
  }
}